import BaseButton from '@/components/bases/BaseButton';
import requester from '@/utils/requester';
import { Form, Input, InputNumber, Modal, Select, Table } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import './styles.css';
import constants from '@/constants';

export interface IBMIScreenProps {}

const getAge = (dateTime: string | Date) => {
  const today = moment();
  const birthday = moment(dateTime);
  let age = '';

  if (birthday.isValid()) {
    const yearsDiff = today.diff(birthday, 'years');
    birthday.add(yearsDiff, 'years');

    const monthsDiff = today.diff(birthday, 'months');
    birthday.add(monthsDiff, 'months');

    const daysDiff = today.diff(birthday, 'days');

    age = `${yearsDiff} tuổi`;

    if (monthsDiff > 0) {
      age += ` ${monthsDiff} tháng`;
    }

    if (daysDiff > 0) {
      age += ` ${daysDiff} ngày`;
    }
  }

  return age;
};

export default function BMIScreen(props: IBMIScreenProps) {
  return (
    <div
      className="flex h-full justify-center items-center bg-cover bg-center"
      style={{ backgroundImage: "url('/images/bg_login.jpg')" }}
    >
      <div className="bg-login w-11/12 lg:w-2/3 p-4">
        <img className="mb-4" src="/images/img_login.png" alt="" />

        <div className="text-3xl uppercase font-bold">Tính chỉ số BMI</div>

        <Form
          className="mx-auto mt-5 w-full"
          layout="vertical"
          name="basic"
          onFinish={(val) => {
            requester
              .post('https://ms.pta.com.vn/health/v1/bmi/calculate_no_user', {
                gender: val.gender,
                birthday: moment(val?.birthday, constants.DATE_FORMAT).toDate(),
                weight: val.weight,
                height: val.height,
              })
              .then((res) => {
                if (res?.data?.bmi?.BMIIndex) {
                  const data = res.data;
                  const objStatus = {
                    OBESITY: 'Béo phì',
                    UNDERWEIGHT: 'Thiếu cân',
                    BELOW_STANDARD: 'Dưới chuẩn',
                    NORMAL: 'Bình thường',
                    OVERWEIGHT: 'Thừa cân',
                  };
                  Modal.success({
                    wrapClassName: '[&_.ant-modal-confirm-content]:!max-w-full',
                    icon: <></>,
                    title: <div className="cms-h1">Thông tin BMI</div>,
                    okButtonProps: {
                      className: 'bg-gradient-1 text-white font-bold rounded-lg ',
                    },
                    content: (
                      <div className="mt-4">
                        <div className="mb-2">
                          <b>Đánh giá:</b>{' '}
                          <b
                            className={`uppercase ${
                              _.get(data, 'bmi.statusBmi') === 'NORMAL' ? 'text-green-600' : 'text-red-600'
                            }`}
                          >
                            {_.get(objStatus, _.get(data, 'bmi.statusBmi'), '')}
                          </b>
                          {moment().diff(_.get(data, 'user.birthday'), 'years') >= 19 ? (
                            <div>
                              <i className="text-gray-600 text-sm">
                                * Lưu ý: Với người trên 19 tuổi chỉ số này ko áp dụng cho người tập luyện thể thao/ vận
                                động viên
                              </i>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>

                        {_.get({ male: 'Nam', female: 'Nữ' }, _.get(data, 'user.gender')) ? (
                          <div className="mb-2">
                            <b>Giới tính:</b> {_.get({ male: 'Nam', female: 'Nữ' }, _.get(data, 'user.gender'))}
                          </div>
                        ) : (
                          ''
                        )}

                        {_.get(data, 'user.birthday') ? (
                          <div className="mb-2">
                            <b>Tuổi:</b> {getAge(_.get(data, 'user.birthday'))}
                          </div>
                        ) : (
                          ''
                        )}

                        <Table
                          size="small"
                          pagination={false}
                          dataSource={[
                            {
                              key: 1,
                              index: 'BMI',
                              val: _.get(data, 'bmi.BMIIndex'),
                              min: _.get(data, 'bmi.zScores.0'),
                              median: _.get(data, 'bmi.mediumBMIIndex'),
                              max: _.get(data, 'bmi.zScores.1'),
                            },
                            {
                              key: 2,
                              index: 'Weight',
                              val: _.get(data, 'bmi.weight'),
                              min: _.get(data, 'bmi.standardWeight.0'),
                              median: _.get(data, 'bmi.mediumWeight'),
                              max: _.get(data, 'bmi.standardWeight.1'),
                            },
                            {
                              key: 3,
                              index: 'Height',
                              val: _.get(data, 'bmi.height'),
                              min: _.get(data, 'bmi.standardHeight.0'),
                              median: _.get(data, 'bmi.mediumHeight'),
                              max: _.get(data, 'bmi.standardHeight.1'),
                            },
                          ]}
                          columns={[
                            {
                              title: 'Chỉ số',
                              key: 'index',
                              dataIndex: 'index',
                            },
                            {
                              title: 'Giá trị',
                              key: 'val',
                              dataIndex: 'val',
                              className: 'font-bold',
                              render(value, record) {
                                const lệch = !record.median
                                  ? 0
                                  : ((record.val - record.median).toFixed(1) as unknown as number);

                                return (
                                  <div>
                                    {value}
                                    {lệch !== 0 ? (
                                      <>
                                        (<span className={lệch > 0 ? 'text-green-500' : 'text-red-500'}>{lệch}</span>)
                                      </>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                );
                              },
                            },
                            {
                              title: 'Min',
                              key: 'min',
                              dataIndex: 'min',
                            },
                            {
                              title: 'Med',
                              key: 'median',
                              dataIndex: 'median',
                            },
                            {
                              title: 'Max',
                              key: 'max',
                              dataIndex: 'max',
                            },
                          ]}
                        />
                      </div>
                    ),
                  });
                }
              });
          }}
          autoComplete="off"
        >
          <div className="flex">
            <div className="px-2 w-1/2">
              <Form.Item
                label={'Cân nặng (Kg)'}
                name="weight"
                required
                rules={[
                  {
                    validator: (_, value) => {
                      if (value <= 2 || value >= 200) {
                        return Promise.reject('Cân nặng phải lớn hơn 2kg và nhỏ hơn 200kg');
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input type="number" className="w-full" placeholder="Nhập cân nặng" />
              </Form.Item>
            </div>
            <div className="px-2 w-1/2">
              <Form.Item
                label={'Chiều cao (Cm)'}
                name="height"
                required
                rules={[
                  {
                    validator: (_, value) => {
                      if (value <= 30 || value >= 250) {
                        return Promise.reject('Chiều cao phải lớn hơn 30cm và nhỏ hơn 250cm');
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber type="number" className="w-full" placeholder="Nhập chiều cao" />
              </Form.Item>
            </div>
          </div>

          <div className="flex">
            <div className="px-2 w-1/2">
              <Form.Item label={'Giới tính'} name="gender">
                <Select
                  placeholder="Chọn giới tính"
                  options={[
                    { value: 'male', label: 'Nam' },
                    { value: 'female', label: 'Nữ' },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="px-2 w-1/2">
              <Form.Item
                label={'Sinh nhật'}
                name="birthday"
                rules={[
                  {
                    pattern: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
                    message: `Vui lòng nhập định dạng ${constants.DATE_FORMAT}.`,
                  },
                ]}
              >
                <Input className="w-full" placeholder={constants.DATE_FORMAT} />
              </Form.Item>
            </div>
          </div>

          <Form.Item>
            <BaseButton.Primary className="w-full mt-5 uppercase" title="Tính" />
          </Form.Item>

          {/* <div>
          <Link className="text-blue-500 mr-4" to="/">
            {i18n.t('common.forgotPassword')}
          </Link>
          <Link
            className="text-blue-500 mr-4"
            to={`/register?urlCallBack=${location.pathname}`}
          >
            {i18n.t('common.register')}
          </Link>
        </div> */}
        </Form>
      </div>
    </div>
  );
}
